export class HistoryStore {
    history: any
}
